import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {CodaltComponent} from '../codalt/codalt.component';
import {Utils} from '../../utils.class';
import {UserService} from '../../services/user.service';
import {AuthorisationService} from '../../services/auth/authorisation.service';
import {AuthenticationService} from '../../services/auth/authentication.service';
import {User} from '../../classes/user';
import {Routenames} from '../../routenames';
import {ConfirmDialogService} from '../../services/confirm-dialog-service/confirm-dialog.service';
import {Role} from '../../classes/role.class';

@Component({
    selector: 'app-user-edit',
    templateUrl: './user-edit.component.html',
    styleUrls: ['./user-edit.component.scss']
})
export class UserEditComponent extends CodaltComponent implements OnInit {

    roles: Role[];

    user: User;

    form: UntypedFormGroup;
    formControls: {
        email: UntypedFormControl,
        name: UntypedFormControl,
        roles: UntypedFormControl,
        emailTicketNotifications: UntypedFormControl
    };

    constructor(private userService: UserService,
                private route: ActivatedRoute,
                private confirmDialogService: ConfirmDialogService,
                private authorisationService: AuthorisationService,
                private authenticationService: AuthenticationService,
                private router: Router) {
        super();
    }

    ngOnInit() {
        this.subscriptions.add(this.authorisationService.getRoles().subscribe(roles => this.roles = roles));
        const id = this.route.snapshot.params['id'];
        if (id === Routenames.CreatePart) {
            this.user = new User();
            this.initForm();
        } else {
            this.subscriptions.add(this.userService.getUser(id).subscribe(res => {
                this.user = res.data;
                if (this.user) {
                    this.initForm();
                } else {
                    this.router.navigate([Routenames.Users]);
                }
            }, error => {
                this.confirmDialogService.confirm('Gebruiker laden mislukt', error.message, 'Terug naar gebruikers', null).then(() => {
                    this.router.navigate([Routenames.Users]);
                }, () => {
                });
            }));
        }

    }

    loginAs() {
        this.authenticationService.loginAsUser(this.user.id).subscribe(token => {
            this.authenticationService.switchToProfile(token.data).subscribe(() => {
                this.router.navigate([Routenames.Home]);
            });
        });
    }

    save() {
        Utils.triggerValidationP(this.form).then(() => {
            if (this.form.valid) {
                const saveUser = JSON.parse(JSON.stringify(this.user)) as User;
                Object.assign(saveUser, this.form.value);

                this.userService.saveUser(saveUser).subscribe(data => {
                    this.router.navigate([Routenames.Users]);
                }, () => {
                });
            }
        }, () => {
        });
    }

    private initForm() {
        this.formControls = {
            email: new UntypedFormControl(this.user.email, [Validators.required, Validators.email]),
            name: new UntypedFormControl(this.user.name),
            roles: new UntypedFormControl(this.user.roles?.map(r => r.key) ?? []),
            emailTicketNotifications: new UntypedFormControl(this.user.email_ticket_notifications ?? true)
        };

        if (this.user.id_4ps) {
            this.formControls.email.disable();
        }

        this.form = new FormGroup(this.formControls);
    }
}
